import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BusinessRulesComponent } from './business-rules/business-rules.component';
import { BarComponent } from './segment/bar/bar.component';
import { CampaignComponent } from './segment/campaign/campaign.component';
import { BlacklistComponent } from './blacklist/blacklist/blacklist.component';
import { WhitelistComponent } from './whitelist/whitelist/whitelist.component';
import { TarriffComponent } from './tarriff/tarriff/tarriff.component';
// import { BarChartDetailsComponent } from './barChart/bar-chart-details/bar-chart-details.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from "./theme/layout/auth/auth.component";
import { from } from 'rxjs';
import { CommunityComponent } from './community/community.component';
import { ReportComponent } from './reports/report/report.component';
import { SubscriberInfoComponent } from './subscriber-info/subscriber-info/subscriber-info.component';
import { RrmsDashboardComponent } from './dashboard/rrms-dashboard/rrms-dashboard.component';
import { NetworkAdditionComponent } from './network-addition/network-addition/network-addition.component';


const routes: Routes = [
  // {path: 'bar-chart', component : BarChartDetailsComponent},
  // {path: '**', component: BarChartDetailsComponent},

  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'authentication/login',
        pathMatch: 'full'
      },
      {
        path: 'authentication',
        loadChildren: () => import('./authentication/authentication.module').then(module => module.AuthenticationModule)
      },
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'Summary',
        component: BarComponent
      },
      {
        path: 'roamers',
        loadChildren: () => import('./segment/roamers.module').then(module => module.RoamersModule)
      },
      {
        path: 'Campaign',
        component: CampaignComponent
      },
      {
        path: 'tarriff',
        component: TarriffComponent
      },
      {
        path: 'blacklist',
        component: BlacklistComponent
      },
      {
        path: 'BusinessRules',
        component: BusinessRulesComponent
      },
      {
        path: 'community',
        component: CommunityComponent
      },
      {
        path: 'whitelist',
        component: WhitelistComponent
      },
      {
        path: 'report',
        component: ReportComponent
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path: 'subscriber-info',
        loadChildren: () => import('./subscriber-info/subscriber-info.module').then(module => module.SubscriberInfoModule)      
      },
      {
        path: 'sms-pdp',
        loadChildren: () => import('./sms-pdp/sms-pdp.module').then(module => module.SmsPdpModule)
      },
      {
        path: 'user-analytics',
        loadChildren: () => import('./user-analytics/user-analytics.module').then(module => module.UserAnalyticsModule)

      },
      {
        path: 'access-management',
        loadChildren: () => import('./access-management/access-management.module').then(module => module.AccessManagementModule)
      },
      {
        path: 'service-live-dashboard',
        loadChildren: () => import('./service-live-dashboard/service-live-dashboard.module').then(module => module.ServiceLiveDashboardModule)
      },
      {
        path:'service-live-dashboard',
        loadChildren: () => import('./network-addition/network-addition.module').then(module => module.NetworkAdditionModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
